import { Button, ConfigProvider, Pagination, PaginationProps, Table, TableColumnsType } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useState } from 'react';
import * as networkApi from '../../../../api/network/networkApi';
import useToast from '../../../../hook/useToast';
import { checkDisabledPermission, dataPagination, getUserPermissions } from '../../../../until';
import ModalAddEmail from '../../Modal/ModalAddEmail';
import ModalEditEmail from '../../Modal/ModalEditEmail';
import './styles.scss'
import { formatNumber } from '../../../../services/mixin';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../../store/slices/permissionSlice';


interface DataTypeSMS {
  key: React.Key;
  nhaMang: string;
  nhaMangImg: string;
  dauSo: string;
  soLuongKyTu: number;
  chiPhi: number;
  category: string

  typeZNSType: string
  numberEmail: number
}

interface PropSMS {
  columns: TableColumnsType<DataTypeSMS>
  listNetwork: DataTypeSMS[]
  infoNetwork?: networkApi.INetwork
  pagination: { current: number, pageSize: number, total: number }
  isModalEdit: boolean

  setIsModalEdit: (value: boolean) => void
  gListNetwork: (pageNumber?: number, pageSize?: number) => void
}



const EmailFeesSetting: React.FC<PropSMS> = ({
  columns, listNetwork, infoNetwork, pagination, isModalEdit,
  gListNetwork, setIsModalEdit
}) => {


  const pushToast = useToast();
   const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download } = getUserPermissions(permissionSlice, location.pathname)

  const [isModalAddTemplate, setIsModalAddTemplate] = useState(false)



  // const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListNetwork(pageNumber, pageSize)
  }


  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsModalAddTemplate(false);
      pushToast(message, "success")
      gListNetwork()
    }
    else {
      pushToast(message, "warning")
    }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsModalEdit(false);
      pushToast(message, "success")
      gListNetwork()
    }
    else {
      pushToast(message, "warning")
    }
  }

  return (

    <div className='custom-page-css h-full flex flex-col'>
      <ModalAddEmail
        isOpen={isModalAddTemplate}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setIsModalAddTemplate(false)}
      />

      <ModalEditEmail
        isOpen={isModalEdit}
        infoNetwork={infoNetwork}

        onSubmitFormModal={onSubmitFormModalEdit}
        closeModal={() => setIsModalEdit(false)}
      />


      <div className="table-top pb-6">
        <span className="font-medium fsz-16 lh-24">Phí gửi Email theo nhà cung cấp</span>
        <Button
          type="primary"
           className={`rs-button primary-outline ${checkDisabledPermission(add)}`}
          onClick={() => setIsModalAddTemplate(true)}
        >Thêm nhà cung cấp</Button>
      </div>

      <div className=" custom-page-css flex flex-col flex-1 justify-between">
        <Table
          columns={columns}
          dataSource={listNetwork}
          showSorterTooltip={false}
          className="rs-table notification-fees-table"
          pagination={false}
        />

        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </div>




  );
}

export default EmailFeesSetting;
